import React from 'react';
import AuthLayout, {
  AuthLayoutProps,
} from '../../../../../components/auth/AuthLayout/AuthLayout';
import imageLandscapeMyBakery from '../../../assets/BakeTouch-OvenCroissant_1620x1080.jpg';

function AuthLayoutMyBakery(props: AuthLayoutProps) {
  return (
    <AuthLayout {...props} imageRight={imageLandscapeMyBakery}>
      {props.children}
    </AuthLayout>
  );
}

export default AuthLayoutMyBakery;
